import { render, staticRenderFns } from "./dataSorce.vue?vue&type=template&id=28374de2&"
import script from "./dataSorce.vue?vue&type=script&lang=js&"
export * from "./dataSorce.vue?vue&type=script&lang=js&"
import style0 from "./dataSorce.vue?vue&type=style&index=0&id=28374de2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports